module.exports = __webpack_public_path__ + "img/oli-1.17967428.png";